import { useEffect, useState } from "react";
import styled from "styled-components";
import { motion, Variants } from "framer-motion";
import { Color, Colors } from "../../models/theme";
import { easings, fill } from "../../styles/utils";
import { Box } from "../Box";
import { AnimationDefinition } from "framer-motion/types/render/utils/animation";

interface TimelineThemeProps {
  bgColor: Color;
}

const Wrapper = styled.div``;

const StaticBg = styled(motion(Box))`
  ${fill()}
  z-index: -1;
`;

const TransitionBg = styled(motion(Box))`
  ${fill()}
  z-index: -1;
`;

export const bodyColorMap: { [key in Color]: "light" | "dark" } = {
  white: "dark",
  blue: "dark",
  blueDark: "light",
  dark: "dark",
  pink: "dark",
  pinkLight: "dark",
  hotPink: "dark",
  violet: "dark",
  violetLight: "dark",
  melonLight: "dark",
  melon: "dark",
  salmon: "dark",
  mint: "dark",
  mintLight: "dark",
  greenLight: "dark",
  green: "light",
};

const staticVariants: Variants = {
  hidden: { opacity: 0 },
  shown: { opacity: 1 },
};
const animateVariants: Variants = {
  hidden: { opacity: 0 },
  shown: { opacity: 1 },
};

export const TimelineTheme: React.FC<TimelineThemeProps> = ({
  bgColor,
  children,
}) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [staticBgColor, setStaticBgColor] = useState(bgColor);

  const handleAnimationComplete = (def: AnimationDefinition) => {
    setStaticBgColor(bgColor);
    setIsAnimating(false);
  };

  useEffect(() => {
    setIsAnimating(true);
  }, [bgColor, setIsAnimating]);

  return (
    <Wrapper>
      <StaticBg backgroundColor={staticBgColor} />
      <TransitionBg
        backgroundColor={bgColor}
        animate={isAnimating ? "shown" : "hidden"}
        variants={animateVariants}
        onAnimationComplete={handleAnimationComplete}
        transition={{ duration: 0.6, ease: "easeIn" }}
      />
      <Box color={bodyColorMap[bgColor] === "dark" ? "blueDark" : "white"}>
        {children}
      </Box>
    </Wrapper>
  );
};
